import { useEffect } from "react";

import { CampaignPromoModal } from "app/components/discountCampaign/CampaignPromoModal/CampaignPromoModal";
import type { ICampaignPromoModalProps } from "app/components/discountCampaign/CampaignPromoModal/types";
import { useCampaignDismiss } from "app/components/discountCampaign/common/hooks/useCampaignDismiss";
import { FIRST_WEEK_MONTHLY_CAMPAIGN_CTA } from "app/components/FirstWeekMonthlyPromo/configs/FirstWeekCampaignConfig";
import { useFirstWeekCampaign } from "app/components/FirstWeekMonthlyPromo/useFirstWeekCampaign";
import { allTrackers } from "app/services/track/track";

const FIRST_WEEK_CAMPAIGN_MODAL_STORAGE_KEY = "first.week.campaign.modal.last.shown";
const FIRST_WEEK_TRACKING_PREFIX = "first week campaign modal";

export const FirstWeekCampaignModal = () => {
    const { firstWeekCtaType, onFirstWeekCtaClick, discountModalProps } = useFirstWeekCampaign();

    const modalInfo = useCampaignDismiss({
        type: "modal",
        isEligible: firstWeekCtaType !== null,
        onCtaClick: onFirstWeekCtaClick,
        storageKey: FIRST_WEEK_CAMPAIGN_MODAL_STORAGE_KEY,
        trackingPrefix: FIRST_WEEK_TRACKING_PREFIX,
        ctaType: FIRST_WEEK_MONTHLY_CAMPAIGN_CTA,
    });

    useEffect(() => {
        if (Boolean(discountModalProps) && modalInfo.isOpen) {
            allTrackers.dispatchTrackEvent("Popup", "show", "Discount Popup/First Week Discount");
        }
    }, [discountModalProps, modalInfo.isOpen]);

    if (!discountModalProps) {
        return null;
    }

    const modalProps: ICampaignPromoModalProps = {
        ...modalInfo,
        discountEndTime: discountModalProps.discountEndTime,
        ...discountModalProps.modalConfig,
    };

    return <CampaignPromoModal {...modalProps} />;
};
